import { env } from "~/env";
import BackButton from "~/screens/Auth/components/BackButton";

export const ProviderSelectionHeader = ({
  handleGoBack,
}: {
  handleGoBack?: () => void;
}) => {
  return (
    <header className="w-full space-y-2">
      <div className="space-y-1">
        <BackButton variant="violet" handleGoBack={handleGoBack} />

        <p className="text-indigo text-sm font-medium lg:text-base">
          Let's book your follow-up visit.
        </p>

        <h1 className="text-indigo font-ivy md:text-4-5xl text-2xl font-light leading-tight">
          Select your usual clinician
        </h1>
      </div>

      <div>
        <p className="text-sm text-gray-700 lg:text-base">
          Don't see your usual clinician or need help booking? Text{" "}
          <a
            href={`tel:${env.VITE_SUPPORT_PHONE_NUMBER_RAW}`}
            className="text-indigo font-medium underline"
          >
            {env.VITE_SUPPORT_PHONE_NUMBER}
          </a>
          .
        </p>
      </div>
    </header>
  );
};
